import React from 'react';
import Slider from 'react-slick';
import RecommendationEntry from './RecommendationEntry';
import {getFromHub} from '../actions/networkActions';

// css styles for the carousel
import '../resources/css/carousel.css';
import ThemableSvgIcon from './theme/ThemableSvgIcon';

class RecommendationSlider extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            recommendations: []
        }
    }

    componentDidMount() {
        getFromHub(this.props.path, this.updateRecommendations);
    }

    updateRecommendations = (recommendations) => {

        this.setState({
            recommendations: recommendations,
        });
    };

    render() {
        const showFullSlider = this.state.recommendations.length >= 4;

        const sliderSettings = {
            dots: true,
            infinite: showFullSlider,
            speed: 500,
            autoplay: showFullSlider,
            autoplaySpeed: 8000,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
            responsive: [
                {
                    breakpoint: 580,
                    settings: { slidesToShow: 1, slidesToScroll: 1 }
                },
                {
                    breakpoint: 1080,
                    settings: { slidesToShow: 2, slidesToScroll: 2 }
                },
                {
                    breakpoint: 1240,
                    settings: { slidesToShow: 3, slidesToScroll: 3 }
                },
            ]
        };

        //if there are no recommendations, just hide the whole section
        if(this.state.recommendations.length < 1) {
            return null;
        }

        return (
            <div className="bg-primary-lighter print-hidden">
                <div className="container mx-auto">
                    <div className="text-primary-dark uppercase">
                        <h2 className="py-4">{this.props.title}</h2>
                    </div>
                    <div className="max-w-full">
                        <Slider {...sliderSettings}>

                            {this.state.recommendations.map((recommendation, index) =>
                                <RecommendationEntry
                                    key={index}
                                    recommendation={recommendation} />
                            )}
                        </Slider>
                    </div>
                </div>
            </div>
        );
    }
}

function PrevArrow({className, onClick}) {
    return (
        <button
            type="button"
            className={className}
            onClick={onClick}
        >
            <ThemableSvgIcon name="chevron-left" className="w-8 h-8 text-primary-dark"/>
        </button>
    );
}

function NextArrow({className, onClick}) {
    return (
        <button
            type="button"
            className={className}
            onClick={onClick}
        >
            <ThemableSvgIcon name="chevron-right" className="w-8 h-8 text-primary-dark"/>
        </button>
    );
}


export default RecommendationSlider;